import { optionalNullableDateInput } from '../zod-helpers/index.js';
function assignOptionalIsoDate(input, key, value) {
    const parsed = optionalNullableDateInput.safeParse(value);
    if (!parsed.success)
        return;
    if (parsed.data === undefined) {
        input[key] = undefined;
        return;
    }
    input[key] = parsed.data === null ? null : parsed.data.toISOString();
}
function includeField(dirtyFields, key) {
    return dirtyFields === undefined || dirtyFields[key] === true;
}
// Field list must stay in sync with buildUpdateData
// (apps/api/src/graphql/types/purchase-order/update-purchase-order.ts) -- see that function's
// comment for why this can't be mechanically derived from the other side.
export function toUpdatePurchaseOrderInput(values, dirtyFields) {
    const input = {};
    if (includeField(dirtyFields, 'locationGroupId')) {
        input.locationGroupId = values.locationGroupId || undefined;
    }
    if (includeField(dirtyFields, 'deliverTo')) {
        input.deliverTo = values.deliverTo ?? null;
    }
    if (includeField(dirtyFields, 'shipToName')) {
        input.shipToName = values.shipToName ?? null;
    }
    if (includeField(dirtyFields, 'shipToAddress')) {
        input.shipToAddress = values.shipToAddress ?? null;
    }
    if (includeField(dirtyFields, 'shipToCity')) {
        input.shipToCity = values.shipToCity ?? null;
    }
    if (includeField(dirtyFields, 'shipToZip')) {
        input.shipToZip = values.shipToZip ?? null;
    }
    if (includeField(dirtyFields, 'note')) {
        input.note = values.note ?? null;
    }
    if (includeField(dirtyFields, 'dateFirstShip')) {
        assignOptionalIsoDate(input, 'dateFirstShip', values.dateFirstShip);
    }
    if (includeField(dirtyFields, 'dateConfirmed')) {
        assignOptionalIsoDate(input, 'dateConfirmed', values.dateConfirmed);
    }
    return input;
}
//# sourceMappingURL=update-mapper.js.map